// extracted by mini-css-extract-plugin
export default {"container":"Section02_container__TLytL","secBox":"Section02_secBox__NDO31","secTitle":"Section02_secTitle__7kcQN","secImg":"Section02_secImg__fMlBy"};